import { ApiPortfolioType } from '@/api'
import { RadioTab, Space } from '@/components/core-v2'
import { PORTFOLIO_TYPE } from '@/constants'

import { StyledDivider } from '../../styles'

interface PortfolioDetailsTypeProps {
  portfolioType: ApiPortfolioType
  setPortfolioType: (type: string) => void
}

export const PortfolioDetailsType = ({
  portfolioType,
  setPortfolioType
}: PortfolioDetailsTypeProps) => (
  <>
    <Space mb={4} mt={5}>
      <StyledDivider />
    </Space>
    <Space mb={4}>
      <label className="radio-group" htmlFor="portfolio-type">
        Portfolio type *
      </label>
    </Space>
    <Space isflex id="portfolio-type" justifyContent="flex-start" mb={-5}>
      <Space mr={4}>
        <RadioTab
          isSelected={portfolioType === PORTFOLIO_TYPE.ModelPortfolio.key}
          onClick={() => setPortfolioType(PORTFOLIO_TYPE.ModelPortfolio.key)}
        >
          {PORTFOLIO_TYPE.ModelPortfolio.value}
        </RadioTab>
      </Space>
      <Space mr={4}>
        <RadioTab
          isSelected={portfolioType === PORTFOLIO_TYPE.FundOfFunds.key}
          onClick={() => setPortfolioType(PORTFOLIO_TYPE.FundOfFunds.key)}
        >
          {PORTFOLIO_TYPE.FundOfFunds.value}
        </RadioTab>
      </Space>
    </Space>
  </>
)
